import { ActivityDto } from "../dtos";

export class Activity {
  id = -1;
  image: string | null = null;
  name = "";
  slot_duration = -1;
  slot_price = -1;
  description: string | null = null;
  reservation_time_slot_increment: number;

  constructor(dto: ActivityDto) {
    this.id = dto.id;
    this.image = dto.avatar ?? null;
    this.name = dto.name;
    this.slot_duration = dto.slot_duration;
    this.slot_price = dto.slot_price;
    this.description = dto.description ?? null;
    this.reservation_time_slot_increment = dto.reservation_time_slot_increment;
  }
}
